// extracted by mini-css-extract-plugin
module.exports = {"card":"_1-4CildSUElTHccDCWjl89","header":"oEInWCZg-Pjyz0xFDqzoc"};